import Pauta from '../components/Pauta';

export default function PautaAndamento() {
  return <Pauta statusPauta="Em Andamento" colunas={[]} corPauta="#1976d2" />;
}